import React from 'react';

import { Helmet } from 'react-helmet';

import { graphql } from 'gatsby';

import HomeHero from '@components/HomeHero';

export default ({ data }) => {
  const home = data.contentfulPage.content[0];

  return (
    <>
      <Helmet title="The Farmhouse" />
      <HomeHero {...home} />
    </>
  );
};

export const query = graphql`
  {
    contentfulPage(contentful_id: { eq: "5VCHg8Bp1wy6xcUxzkgJAD" }) {
      content {
        ...PageHero
      }
    }
  }
`;
